const zh = {
  nav: {
    home: '首页',
    product: '产品',
    QA: '常见问题',
    explore: "立即前往",
    login: '登录',
    register: '注册',
    registerNow: '立即注册',
    demoStore: '立即体验',
    slideTitle: '全球收单',
    slideTitleSplit: '面向50亿消费者',
    slideChoiceTitle: "品质之选",
    slideBrandTitle: "深受全球知名品牌信赖",
    footerAgreement: '特约商户服务协议',
    email: '咨询邮箱',
    back: '返回',
  },
  feature: {
    coverage: "<strong>覆盖全球</strong>71个国家及地区，<br />266种支付方式，50+币种。",
    optimization: "优化支付过程中每个关键节点，<br /><strong>提高支付成功率</strong>。",
    ecological: "开放支付生态和API体系，<br />保证接口<strong>高可用性和稳定性<strong>。",
    compliance: "支付牌照覆盖美、日、欧、中国香港，具备广泛的<br />全球性合作银行网络和<strong>全球合规支付体系</strong>。",
    fraud: "通过风险策略、数据模型，实施全方面、<br />多角度的实时交易监控，进行<strong>欺诈保护</strong>。",
    client: "为每个客户配备<strong>专业的服务团队</strong>，<br />分析交易数据，寻找客户的增长点。"
  },
  globalDeploy: {
    title: "全球化一键部署",
    desc: [
      "与全球六大卡组织建立合作",
      "支持法国、阿根廷、巴西等本地卡组，Cartes Bancaires、Cabal、Tarjeta Naranja、Elo",
      "支持欧洲、北美、日本、韩国、东南亚、中国香港等主流本地化支付",
      "支持全新的BNPL（Buy Now , Pay Later）产品"
    ],
  },
  eco: {
    title: "生态联盟",
    subTitle: "让支付变得更简单",
  },
  bizScenario: {
    mainTitle: "适合多业务场景的在线支付",
    subTitle: "为商户提供全方位支付方案，助力商户优化用户体验。",
    background: "背景",
    challenge: "挑战",
    solution: "解决方案",
    onlineRetailers: {
      label: "电商",
      mainTitle: "某DTC独立站大卖",
      subTitle: "传统工贸企业转型跨境电商的典范",
      background: "客户专注聚焦于键盘类产品，在欧美地区拥有强大的品牌影响力",
      challenge: [
        "急需提升信用卡支付成功率",
        "增加本地支付，提升消费者的转化率与复购率",
        "希望能找到一家合作伙伴，可以同时提供收单服务和供应商付款服务，节省公司的运营成本"
      ],
      solution: [
        "智能路由全球收单银行，信用卡收单成功率显著提升",
        "提供欧美本地化支付方式，消费者可自主选择支付方式完成购买，转化率及复购率效果明显",
        "提供全链路资金解决方案，包含收单、供应商付款、货币兑换等",
        "全天候服务：7*24小时的运营对接，答疑解惑",
      ]
    },
    study: {
      label: "留学",
      mainTitle: "国内在线留学缴费领跑者",
      subTitle: "一站式服务平台，解决学费、申请费、宿舍费等跨境缴费难题",
      background: "客户计划打造留学生生活平台APP，为留学生提供吃喝玩乐游购娱优惠买单服务",
      challenge: [
        "急需为海外欧美留学生提供绑卡代扣服务",
        "针对不同品类的商户有不同的分账规则，且需要分发至商户的本地银行账户"
      ],
      solution: [
        "提供完整的针对持卡人的绑卡、代扣功能",
        "支持平台和商户之间的分账，可视化的分发流水及账户余额记录",
        "多币种分发，强大的海外路由，极大提升客户分发效率"
      ]
    },
    takeOutFood: {
      label: "外卖",
      mainTitle: "全球知名中餐外卖平台",
      subTitle: "致力于推动海外华人餐饮行业的数字化进程",
      background: "客户在韩国，从服务海外华人拓展到本地群体",
      challenge: [
        "需要韩国本地支付方式，包括卡类，网银，钱包等所有支付类型",
        "开发资源有限，希望投入最少人力完成所有方式的对接",
        "需要适配现有收银台"
      ],
      solution: [
        "提供韩国本地8大银行，3大钱包，主流网银，以及海外双标信用卡",
        "适配商户的开发资源、定制需求和交付速度"
      ]
    },
    travel: {
      label: "出行",
      mainTitle: "出行行业独角兽",
      subTitle: "拓展国际业务，加速全球化进程",
      background: "客户需要在海外快速开展本地车服业务，为海外用户提供出行服务",
      challenge: [
        "需要对海外的分包商和司机做KYB",
        "急需接入各国的本地支付方式",
        "出行行业在海外不同地区的支付规则不同，需要专家经验"
      ],
      solution: [
        "提供KYB 服务，简化KYB流程，专业团队协助客户线下完成",
        "为东南亚、欧洲客户以及海外华人提供本地化支付方式",
        "虚拟商品强大的交易风控，帮助客户提高请款成功率的前提下控制拒付率"
      ]
    }
  },
  footerBlock: {
    title: "开启全球之旅",
    register: "立即注册使用",
  },
  footerCopy: {
    copyright:
      '©2015-%{year} checkout.pingpongx.com. 杭州乒乓智能技术有限公司 All Rights Reserved.<br>浙ICP备15025700号-1. 经营许可证:合字B2-20200174 浙公网安备33010802003226号'
  },
  product: {
    productTitle: "选择PingPong Checkout",
    productIntro:
      "使用PingPong Checkout，您可用1个账户，便捷管理所有独立站的收单，用1个API，实现50多个币种的交易。",
    productSubIntro: "在安全、人性化的基础上，获得更高效的收单体验",
    productIntroBtn: "立即注册使用",
    listLanTitle: "提高成功率",
    listLanP1: "支持多种开发语言",
    listLanP2: "页面无需跳转即可支付",
    listLanP3: "减少流失率",
    listMbTitle: "优化移动用户体验",
    listMbP1: "领先的移动SDK技术",
    listMbP2: "完整支持ApplePay和GooglePay",
    listMbP3: "助您提升用户体验",
  },
  serve: {
    serveTitle: "产品与服务",
    serveList1: "交易反欺诈",
    serveList2: "国际信用卡支付网关",
    serveList3: "汇款统一结算",
    specialListTitle: "全球合规的支付体系",
    specialListIntro1st:
      "国内少数同时拥有中国、中国香港、美国、欧洲、日本支付牌照的跨境收单企业",
    specialListIntro2nd: "具备广泛的全球性合作银行网络",
    specialListIntro3rd: "连续多年获得国际权威第三方合规评估机构的最高评级",
    specialRiskTitle: "国际领先的风控解决方案",
    specialRiskIntro1st: "强大的风控反欺诈系统 保障账户资金安全",
    specialRiskIntro2nd: "3-D Secure",
    specialRiskIntro3rd: "PCI DSS 3.2认证",
    specialSettlementTitle: "贴心的结算方式",
    specialSettlementIntro1st: "灵活的保证金策略",
    specialSettlementIntro2nd: "结算方式多样化",
    companyName: "杭州乒乓智能技术有限公司",
  },
  pay: {
    payTitle: "海外支付",
    paySubTitle: "一个API即可接入移动端、PC端收单",
    paySubTitleSplit: "接受多种主流币种、国际信用卡",
    payItem1st: "国际信用卡",
    payItem2nd: "本地支付",
    payItem3rd: "移动支付",
  },
  partner: {
    partnerTitle: "合作伙伴",
    faqTitle: "常见问题",
  },
  faq: [
    {
      id: 1,
      category: "商户对接",
      menu: [
        {
          id: 8,
          title: "上线前",
          question: [
            {
              q: "PingPong Checkout注册步骤",
              a: [
                "1、实名认证环节：点击【账户中心】（右上角）→ 【实名认证】",
                "2、添加打款账户：点击【账户中心】（右上角） ",
                "3、添加网站：点击【网站管理】 ",
                "4、第二步和第三步无强关联，顺序可互换"
              ],
            },

          ],
        },
      ],
    },
    {
      id: 2,
      category: "测试环节",
      menu: [
        {
          id: 9,
          title: "shopify建站",
          question: [
            {
              q: "shopify更新，各支付服务商需要在2022年7月31日前完成新版安装，是否会影响使用",
              a: "这个提示是因为 Shopify 正在对其支付平台进行更新。PingPong Checkout将分批次通知您安装新的支付应用程序，预计在2022年6月30日前完成更新，更新后将不会影响支付服务，请耐心等待；后续我们会与您沟通并引导切换，感谢支持",
            },
            {
              q: "测试报错technical reason",
              a: [
                "请确认建站平台设置",
                "1、测试模式是否取消",
                "2、邮寄地址是否设置",
              ],
            },
            {
              q: "新版安装后页面卡标无法展示",
              a: "shopify建站更新后，网页卡标不会展示出来，客户下单还是正常显示的；pingpong已和shopify沟通优化",
            },
          ],
        },
        {
          id: 10,
          title: "Shoplazza",
          question: [
            {
              q: "店匠如何安装？",
              a: "您好，需要您去PingPong Checkout后台：https://checkout.pingpongx.com/ ，在【系统管理】菜单中的【密钥设置】获取一下相关参数，将具体的店铺ID、client id、密钥复制到店匠后台中。【商户ID就是填写client ID，账号ID就是填写accID】",
            },
          ],
        },
        {
          id: 11,
          title: "self-build",
          question: [
            {
              q: "自建站对接流程",
              a: "前期需要双方技术人员参与技术对接后，完成沙箱环境测试。审批到运营同学完成生产配置并测试",
            },
          ],
        },
        {
          id: 12,
          title: "测试",
          question: [
            {
              q: "店铺测试",
              a: "您好，建议自行测试或关注后续交易情况；如需pingpong协助测试，请提供1美金测试链接。（目前仅支持V/M卡测试，如涉及本地银行卡支付或其他卡品牌，运营无法测试）",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      category: "订单相关",
      menu: [
        {
          id: 13,
          title: "支付方式",
          question: [
            {
              q: "PingPong Checkout目前支持哪些支付方式？",
              a: "目前支持的卡品牌包括：VISA、Mastercard、JCB、DinersClub、Discover、American Express（如需新增本地化支付请联系销售经理）",
            },
          ],
        },
        {
          id: 14,
          title: "支付报错（常见问题）",
          question: [
            {
              q: "PingPong Checkout商户后台，订单失败原因查询路径",
              a: "交易管理--交易查询--输入网站订单号/交易流水号--点击蓝色交易流水号查看具体失败原因"
            },
            {
              q: "Do not honor",
              a: "您好，由于交易限制，发卡行不信任或者信用卡跨境交易有限额等原因，需要持卡人联系发卡行，或者换卡支付"
            },
            {
              q: "3D validation failed/3D验证失败",
              a: "您好，持卡人在支付这笔订单的时候因为安全性的问题，比如存在盗刷可能性等等 需要他进行指纹或者人脸验证亦或者短信验证，持卡人验证失败；请持卡人输完信息后不要关闭页面支付，另外信息要确认输入正确"
            },
            {
              q: "Transaction declined（invalid card/cardholder authentication verification failure/limit exceeded/expired card）",
              a: "您好，由于发卡行返回该卡无效/持卡人授权验证失败/支付金额超限/过期卡，建议持卡人确认卡片有效验证信息"
            },
            {
              q: "Transaction declined（High risk transaction）",
              a: "您好，这笔交易是风控检测到有风险，所以拒绝"
            },
            {
              q: "Transaction declined(other reason)",
              a: "您好，如遇此类报错建议反馈微信群或者销售经理协助解决"
            },
            {
              q: "Received external system response timeout",
              a: "您好，系统超时关闭订单，生成订单后需要持卡人尽快完成支付，否则订单会超时失败"
            },
            {
              q: "退款后多久能到账",
              a: "退款时间具体要看发卡行的入账速度的，一般是7个工作日到1个月之间，建议持卡人联系发卡行确认"
            },
            {
              q: "退款失败",
              a: [
                "退款失败有如下情况：",
                "1、持卡人已针对这笔订单发起拒付，所以无法退款",
                "2、退款时间已超出银行限制（一般为180天，个别银行时间有出入）",
                "3、发卡行为俄罗斯、乌克兰等制裁国家退款失败",
                "4、除以上原因外，请提供PS开头的支付订单号给到群里的运营，运营会跟进解决",
              ]
            },
          ],
        },
        {
          id: 15,
          title: "订单状态",
          question: [
            {
              q: "交易类型为审核通过（approve）的订单，状态为success，为什么没有结算？",
              a: "交易类型为审核通过（Approve）、审核拒绝（Reject）的订单，均为风险订单的审核订单，分别对应交易类型为消费_成功，消费_取消，且不计入结算。核对交易、结算订单时，仅需依照交易类型为消费的订单即可。"
            },
            {
              q: "待审核订单（Review）",
              a: "一般会在24小时内处理完成"
            },
            {
              q: "拒付订单",
              a: "如果有拒付订单，可邮件查收或在PingPong Checkout后台的【风险管理】—【调单拒付管理】找到此笔交易并申诉；建议先和买家联系沟通"
            },
            {
              q: "如何在系统里查看风险订单？",
              a: "登陆PingPong Checkout后台，风险管理--风险订单管理，可查询"
            },
            {
              q: "客户下单之后 订单状态显示pending，pingpong后台查不到这笔交易吗？",
              a: "pending订单表示用户没有发起支付，只是请求到了收银台页面"
            },
          ],
        }
      ],
    },
    {
      id: 4,
      category: "提现",
      menu: [
        {
          id: 16,
          title: "账户设置",
          question: [
            {
              q: "VA账户如何添加",
              a: "您好,可在PingPong Checkout后台—右上角【账户中心】—【提现账户】，直接添加VA；可参考【VA提现操作指南】"
            },
            {
              q: "银行账户如何添加",
              a: "一般需要对公账户，支持收美金。"
            }
          ]
        },
        {
          id: 17,
          title: "账户审核",
          question: [
            {
              q: "提现账户审核时效",
              a: "VA提现账户，不要人工审核；添加其他银行账户，需联系销售经理反馈风控审核通过"
            }
          ]
        },
        {
          id: 18,
          title: "到账时效",
          question: [
            {
              q: "发起提现后需要多久才能到账",
              a: "提现一般需要1-3个工作日到账，如提现至VA账户当天即可到账"
            }
          ]
        },
        {
          id: 19,
          title: "额度不足",
          question: [
            {
              q: "提现VA，至pingpong主站提现额度不够",
              a: [
                "如有人民币结汇需求，",
                "1、请及时绑定物流插件并在PingPong Checkout后台提现账户中添加虚拟账户（币种：USD）;",
                "2、订单管理-查询未上传状态订单-目前这个上传状态的判断逻辑是商品名称和物流单号都要填，才显示绿色的已上传状态，系统如未抓取到商户名称那就要手动填写",
              ]
            }
          ]
        }
      ],
    },
    {
      id: 5,
      category: "费率/报价",
      menu: [
        {
          id: 20,
          title: "费用收取",
          question: [
            {
              q: "手续费如何收取？",
              a: "您好，手续费是按照固定费用加比例的计算方式，具体可参考合同费率或者联系销售经理"
            },
            {
              q: "拒付费用如何收取？",
              a: "您好，请确认合同中拒付费用收取情况，如对具体订单有疑问可提供交易流水号至我们查询"
            },
            {
              q: "提现手续费扣除规则？",
              a: "提现手续费（请参考合同）均从商户发起的提现金额中扣除。商户输入提现金额时，会提示手续费金额及实际到账金额。"
            },
            {
              q: "什么是循环保证金？",
              a: "循环保证金是指按每笔交易金额的10%收取的保证金总额，周期180天后释放计入可提现金额（具体请参考合同）"
            },
            {
              q: "拒付预警费用",
              a: "您好，拒付预警的机制是在我们的系统识别到欺诈类拒付即将发起时，会对这笔订单操作退款，退款后这笔订单就不会转化成拒付订单，而是一笔退款订单，以此降低您的拒付率；针对这个操作会收取一笔拒付预警费用"
            },
          ]
        },
        {
          id: 21,
          title: "对账单",
          question: [
            {
              q: "对账问题",
              a: "您好，对账以后台报表管理--下载的月度资金对账单为准，请参考此维度对账；（如若反馈对账单明细和建站工具后台有差异，请提供差异订单list，我们会反馈技术定位问题）"
            },
            {
              q: "对账单里的拒付和其他对账单周期显示不一致，是为什么？",
              a: "您好，交易和退款等的对账单是按照合同的结算周期，拒付的话是发生就会计入的"
            }
          ]
        },
        {
          id: 22,
          title: "结算",
          question: [
            {
              q: "按原币种结算",
              a: "您好，请联系对应销售"
            },
            {
              q: "什么时候结算",
              a: "请参考合同中的结算周期，如遇国内节假日或渠道休假结算顺延"
            }
          ]
        }
      ],
    },
    {
      id: 6,
      category: "物流",
      menu: [
        {
          id: 23,
          title: "物流插件",
          question: [
            {
              q: "如何绑定",
              a: [
                "针对Shopify/Shoplazza建站的店铺，可实现自动获取物流单号，具体操作方法如下：",
                "1）进入PingPong Checkout网站管理；",
                "2）点击右侧省略符，选择“物流绑定”；",
                "3）填写shopify后台管理账号域名；",
                "4）登录shopify账号后，根据指引，安装PingPong Checkout应用。"
              ]
            }
          ]
        }
      ],
    },
    {
      id: 7,
      category: "组织规则",
      menu: [
        {
          id: 24,
          title: "组织规则",
          question: [
            {
              q: "AMEX Merchant Rules",
              a: '<a href="https://cdn17.pingpongx.com/static_platform/acquirer/AMEXMerchantRules.html" target="_blank" style="color: #2288E3;">查看详情</a>',
            },
            {
              q: "Klarna Merchant Rules",
              a: '<a href="https://cdn17.pingpongx.com/static_platform/acquirer/KlarnaMerchantRules.html" target="_blank" style="color: #2288E3;">查看详情</a>',
            },
            {
              q: "Prohibited Business",
              a: '<a href="https://cdn17.pingpongx.com/static_platform/acquirer/ProhibitedBusiness.html" target="_blank" style="color: #2288E3;">查看详情</a>',
            },
            {
              q: "iDeal Merchant Rules",
              a: '<a href="https://cdn17.pingpongx.com/static_platform/acquirer/iDealMerchantRules.html" target="_blank" style="color: #2288E3;">查看详情</a>',
            },
            {
              q: "Sofort Merchant Rules",
              a: '<a href="https://cdn17.pingpongx.com/static_platform/acquirer/SofortMerchantRules.html" target="_blank" style="color: #2288E3;">查看详情</a>',
            },
          ],
        },
      ],
    },
  ],
};

export default zh;
